import { Modal, Box, Button, Typography, Fab } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import PasswordIcon from '@mui/icons-material/Password'
import OTPInput from 'react-otp-input'
import './2fa.scss'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const OTPModal = ({ open, onClose, onVerify, otp, setOtp }) => {
  const { theme } = useSelector((state) => state.theme)
  const { t } = useTranslation(['common', 'messages'])

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="2fa-modal-title" aria-describedby="2fa-modal-description">
      <Box className="modal" sx={{ justifyContent: 'center' }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', width: '100%' }}>
          <PasswordIcon sx={{ gridColumn: '2', justifySelf: 'center', fontSize: '2.4rem' }} />

          <Fab variant="close" onClick={onClose} sx={{ gridColumn: '3', justifySelf: 'end' }}>
            <CloseOutlinedIcon />
          </Fab>
        </Box>

        <>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="title">{t('messages:login.otp.enterCode')}</Typography>
            <Typography variant="subtitle3">{t('messages:login.otp.enter6Code')}</Typography>
          </Box>

          <OTPInput
            inputStyle={`otp-input ${theme === 'dark' ? 'otp-input-dark' : 'otp-input-light'}`}
            renderSeparator={<span style={{ margin: '0 8px' }}>-</span>}
            value={otp}
            onChange={setOtp}
            numInputs={6}
            shouldAutoFocus
            renderInput={(props) => <input {...props} data-1p-ignore inputMode="numeric" />}
          />

          <Button onClick={onVerify} variant="contained" fullWidth>
            {t('common:verify')}
          </Button>
        </>
      </Box>
    </Modal>
  )
}

export default OTPModal
